import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (color, label) => L.divIcon({
  className: "",
  html: `<div style="transform:translate(-50%,-100%);display:flex;flex-direction:column;align-items:center">
    <div style="background:${color};width:16px;height:16px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35)"></div>
    ${label ? `<span style="margin-top:3px;font:600 11px/1.1 Figtree,sans-serif;color:#14481B;background:rgba(255,255,255,.9);padding:1px 6px;border-radius:9px;white-space:nowrap;box-shadow:0 1px 3px rgba(0,0,0,.2)">${label}</span>` : ""}
  </div>`,
  iconSize: [0, 0],
  iconAnchor: [0, 0],
});

export default function ZoneMap({ center, radiusKm = 60, cities = [], className = "" }) {
  const elRef = useRef(null);
  const citiesKey = JSON.stringify(cities);

  useEffect(() => {
    if (!elRef.current || !center?.lat || !center?.lng) return;
    const map = L.map(elRef.current, { scrollWheelZoom: false, zoomControl: true, attributionControl: true });
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; OpenStreetMap', maxZoom: 19,
    }).addTo(map);

    const c = [center.lat, center.lng];
    const circle = L.circle(c, {
      radius: (radiusKm || 60) * 1000,
      color: "#2EB82E", weight: 2, opacity: 0.8,
      fillColor: "#2EB82E", fillOpacity: 0.08,
    }).addTo(map);

    L.marker(c, { icon: pin("#A66E3F", "Acanthe Jardins"), zIndexOffset: 1000 })
      .addTo(map).bindPopup("<b>Acanthe Jardins</b><br>Saint-Victoret (13730)");

    (cities || []).forEach((ci) => {
      if (ci && ci.lat && ci.lng) {
        const popup = ci.slug
          ? `<b>${ci.name}</b><br><a href="/conseils/${ci.slug}" style="color:#2EB82E;font-weight:600">Voir la page</a>`
          : `<b>${ci.name}</b>`;
        L.marker([ci.lat, ci.lng], { icon: pin("#2EB82E", ci.name) }).addTo(map).bindPopup(popup);
      }
    });

    try { map.fitBounds(circle.getBounds(), { padding: [30, 30] }); }
    catch { map.setView(c, 9); }

    setTimeout(() => map.invalidateSize(), 200);

    return () => map.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [center?.lat, center?.lng, radiusKm, citiesKey]);

  return <div ref={elRef} className={className} style={{ height: "100%", width: "100%", zIndex: 0 }} data-testid="zone-map" />;
}
